import {
  GETWALLETOWNERLIST_SUCCESS,
  GETWALLETOWNERLIST_FAILED,
  RESET_GETWALLETOWNERLIST,
  LOADING_GETWALLETOWNERLIST,
  NETWORK_ERROR_GETWALLETOWNERLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETWALLETOWNERLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETWALLETOWNERLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETWALLETOWNERLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETWALLETOWNERLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETWALLETOWNERLIST:
      return (state = initialState);
    default:
      return state;
  }
};
